import * as React from 'react';
import { Loading } from '@components/Loading/Loading';
import styled from 'styled-components';
import { Box } from '@kite-js/core';
import { registerSetViewHeight } from '@utils/registerSetViewHeight';

type Props = {
    isLoading: boolean;
};

registerSetViewHeight();

// This should not be used with scrollable content
const FitViewPortHeightPage = styled(Box)`
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
`;

export const LoadingPage: React.FC<Props> = props => (
    <FitViewPortHeightPage width="100vw">
        <Loading
            // tslint:disable-next-line: jsx-no-multiline-js
            wrapperBox={{
                height: '100%',
                width: '100%',
                style: {
                    backgroundColor: 'white',
                },
            }}
            isLoading={props.isLoading}
            dottedProgress={{ size: 'M' }}
        >
            {props.children}
        </Loading>
    </FitViewPortHeightPage>
);
